import { UiFramework } from '../../../definition/context-types';
import GrommetDetailGenerator from './grommet-detail-generator';
import MuiDataDetailGenerator from './mui-detail-generator';
var DetailGeneratorFactory = /** @class */ (function () {
    function DetailGeneratorFactory(context, entity) {
        this._context = context;
        this._entity = entity;
    }
    DetailGeneratorFactory.prototype.getDetailGenerator = function () {
        var generator = new MuiDataDetailGenerator(this._context, this._entity);
        switch (this._context.uiFramework) {
            case UiFramework.Grommet:
                generator = new GrommetDetailGenerator(this._context, this._entity);
                break;
            case UiFramework.MaterialUI:
                generator = new MuiDataDetailGenerator(this._context, this._entity);
                break;
        }
        return generator;
    };
    return DetailGeneratorFactory;
}());
export { DetailGeneratorFactory };
